module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/770c1f3eca5a0d7c327c275865dad3f0.svg";